var _circle, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYumiLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 127,
    viewBox: "0 0 127 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 63.5,
    cy: 63.5,
    r: 63.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.5736 69.7776C49.4269 72.594 43.9613 74.2877 38.4597 74.9651C38.6582 75.3645 38.8652 75.7618 39.0848 76.157C46.6223 89.6601 63.79 94.555 77.4288 87.0904C91.0675 79.6279 96.0115 62.6308 88.4741 49.1276C85.7391 44.2286 81.7328 40.4691 77.0909 38.0144C74.9832 50.9948 67.0973 62.9235 54.5736 69.7755V69.7776Z",
    fill: "url(#paint0_linear_128_1538)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3349 59.8459C46.3919 52.7849 46.734 44.5258 50.5038 38C50.3792 38.0648 50.2525 38.1255 50.13 38.1924C36.4934 45.657 31.5473 62.6519 39.0868 76.1551C46.6242 89.6583 63.792 94.5531 77.4307 87.0885C88.7189 80.912 94.043 68.2054 91.2701 56.352C89.5193 61.3702 85.9607 65.7904 80.8985 68.5609C70.0284 74.5096 56.3454 70.6079 50.337 59.8459H50.3349Z",
    fill: "#7953FF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_128_1538",
    x1: 59.5753,
    y1: 47.9468,
    x2: 68.6594,
    y2: 78.7952,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#6E4FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#34179E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYumiLogo);
export default __webpack_public_path__ + "static/media/yumiLogo.bfc12997f1ddc4ec2da95ac530d04507.svg";
export { ForwardRef as ReactComponent };